import { Component, OnDestroy, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { Subject, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";

import { AnalyzeReportSupervisorModel } from "src/app/models/analyze-report-supervisor-model";
import {
  STORAGE_KEY_CURRENT_USER,
  STORAGE_KEY_UUID_SUPERVISOR,
} from "src/app/storageCore/constStorageKeys";
import storageX from "src/app/storageCore/storageX";

import { MatTableDataSource } from "@angular/material/table";
import { PageEvent } from "@angular/material/paginator";
import { AnalyzeReportSupervisorModelPaginated } from "src/app/models/analyze-report-supervisor-model-paginated";
import { Router } from "@angular/router";
import { DatePipe } from "@angular/common";

import Swal from "sweetalert2";
import { AnalyzeTripService } from "src/app/services/analyze-trip.service";
import { MatDialog } from "@angular/material/dialog";
import { MinioService } from "src/app/services/minio.service";
import { PermissionsService } from "src/app/helpers/permissions.service";

@Component({
  selector: "app-supervisor-analysis",
  templateUrl: "./supervisor-analysis.component.html",
  styleUrls: ["./supervisor-analysis.component.scss"],
})
export class SupervisorAnalysisComponent implements OnInit, OnDestroy {
  public analyzeTripService: AnalyzeTripService;
  public minioService: MinioService;
  public datePipe: DatePipe;

  public analyzeReportSupervisorModelsPaginated: AnalyzeReportSupervisorModelPaginated;
  public analyzeReportSupervisorModel: AnalyzeReportSupervisorModel;
  public errorMessage;
  public analyzeReportSupervisorsPage: AnalyzeReportSupervisorModelPaginated;
  public analyzesManagers: MatTableDataSource<any> =
    new MatTableDataSource<any>();
  public tableColumns: string[];
  public typeFieldSelect = [
    { name: "Número Pacote", value: "PACKAGE" },
    { name: "Motorista", value: "DRIVER" },
    { name: "Placa", value: "PLATE" },
    { name: "Base Opera.", value: "BASE" },
    { name: "Nome Operador", value: "OPERATOR" },
  ];

  public actualPage: PageEvent;
  public permissions: [];
  public filter = "";
  public field = "";
  public typeFieldFilterSelected;
  private intervalId: any;
  private filterSearch$ = new Subject<string>();
  private filterSearchSubscription: Subscription;
  private readonly filterDebounceMs = 400;

  constructor(
    datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    public router: Router,
    analyzeTripService: AnalyzeTripService,
    minioService: MinioService,
    public dialog: MatDialog,
    public permissionService: PermissionsService
  ) {
    this.datePipe = datePipe;
    this.analyzeTripService = analyzeTripService;
    this.minioService = minioService;
  }

  ngOnInit(): void {
    this.permissions = this.permissionService.getPermissions();
    this.typeFieldFilterSelected = this.typeFieldSelect[0].value;
    this.field = this.typeFieldFilterSelected;
    this.initialPage();
    this.setupFilterDebounce();
    this.loadReports(this.actualPage, this.filter, this.field);
    this.loadTableDefinitions();
    //this.startCallingLoadReports();
  }

  private setupFilterDebounce(): void {
    this.filterSearchSubscription = this.filterSearch$
      .pipe(debounceTime(this.filterDebounceMs), distinctUntilChanged())
      .subscribe(() => {
        this.actualPage.pageIndex = 0;
        this.loadReports(this.actualPage, this.filter, this.field, true);
      });
  }

  ngOnDestroy(): void {
    this.stopCallingLoadReports();
    this.filterSearchSubscription?.unsubscribe();
    this.filterSearch$.complete();
    this.spinner.hide();
  }

  // private startCallingLoadReports(): void {
  //   console.log("Data atual:", new Date());
  //   this.intervalId = setInterval(() => {
  //     this.loadReports(this.actualPage, this.filter, this.field);
  //   }, 30000); // Chama o método loadReports a cada 30 segundos
  // }

  private stopCallingLoadReports(): void {
    clearInterval(this.intervalId); // Para de chamar loadReports
  }

  private loadReports(
    page: PageEvent,
    name: string,
    field: string,
    showSpinner = true
  ): void {
    if (showSpinner) {
      this.spinner.show();
    }

    var uuidSupervisor: string = storageX
      .whereKeyIs(STORAGE_KEY_UUID_SUPERVISOR)
      .get();
    this.analyzeTripService
      .getAllAnalyzeReportSupervisor(page, uuidSupervisor, name, field)
      .subscribe(
        (t) => {
          this.analyzeReportSupervisorsPage = t;
          this.analyzesManagers =
            new MatTableDataSource<AnalyzeReportSupervisorModel>(
              this.analyzeReportSupervisorsPage.content
            );
          if (showSpinner) {
            this.spinner.hide();
          }
        },
        (error) => {
          console.log("Erro ao obter as analises do operador");
          if (showSpinner) {
            this.spinner.hide();
          }
        }
      );
  }

  applyFilter(): void {
    this.filterSearch$.next(this.filter);
  }

  openToTreatment(uuid: string) {
    const url = "/analise-supervisor/tratamento-operador/" + uuid;
    window.open(url, "_blank");
  }

  fieldFilter(): void {
    this.field = this.typeFieldFilterSelected;
    this.filter = "";
  }

  private loadTableDefinitions(): void {
    this.tableColumns = [
      "packageNumber",
      "dateStart",
      "dateEnd",
      "operationalBase",
      "companyDestiny",
      "driverName",
      "plate",
      "OperadorName",
      "operatorHandling",
      "managerName",
      "treatManagerName",
      "descriptionManager",
      "rejectionSupervisor",
      "finish",
    ];

    if (
      this.permissionService.hasPermission(
        "ANALYZE_MINIO_FUNCIONALIDADE",
        this.permissions
      )
    ) {
      this.tableColumns.push("filePdfAnalytical", "filePdfSynthetic");
    }
  }

  public async handleFinish(element): Promise<void> {
    Swal.fire({
      icon: "warning",
      title: "Finalizar Análise",
      html: `<h6>Tem certeza que você deseja finalizar essa analise? </h6>`,
      showCloseButton: false,
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonText: "Cancelar",
      showConfirmButton: true,
      confirmButtonText: "Confirmar",
      focusConfirm: false,
    }).then((action) => {
      if (action.isConfirmed) {
        this.analyzeFinish(element);
      }
    });
  }

  analyzeFinish(element): void {
    this.spinner.show();

    var operator = storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id;
    this.analyzeTripService.finishSupervisor(operator, element.uuid).subscribe(
      (v) => {
        console.log("Analise finalizada com sucesso");
        this.loadReports(this.actualPage, this.filter, this.field);

        const url = "/analise-supervisor/form-penalties/" + element.uuid;
        window.open(url, "_blank");

        this.spinner.hide();
      },
      (e) => {
        console.log("Erro ao finalizar analise");
        this.spinner.hide();
        this.errorMessage = e.message;
        throw new EvalError(e);
      }
    );
  }

  exportReport(element): void {
    this.minioService.exportReport(element).subscribe();
  }

  onChangePage(event: PageEvent): void {
    this.actualPage = event;
    this.loadReports(this.actualPage, this.filter, this.field);
  }

  private initialPage(): void {
    this.actualPage = new PageEvent();
    this.actualPage.pageIndex = 0;
    this.actualPage.pageSize = 20;
  }
}
